import { ISectionInitialState } from "../../../types/permissions/sectionInterface";
import { SectionActionTypes, SectionActions } from "../../actionTypes/permissions/sectionActionTypes";


const initialState: ISectionInitialState = {
  sectionList: [],
  sectionListPageCount: 0,
};

export default function sectionReducer(state = initialState, action: SectionActionTypes): ISectionInitialState {
  switch (action.type) {
    case SectionActions.SET_SECTION_LIST:
      return {
        ...state,
        sectionList: action.payload,
      };

    case SectionActions.SET_SECTION_PAGE_COUNT:
      return {
        ...state,
        sectionListPageCount: action.payload
      };


    default:
      return state;
  }
}
